export default function yearMonthToDateKey(year, month) {
	return `${month}-${year}`;
};

yearMonthToDateKey.convertToSelectedDatesString = function(dateKey) {
	const split = dateKey.split('-');
	split.reverse();
	const monthValue = parseInt(split[1]);
	split[1] = monthValue - 1;
	return split.join('-');
};